import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'

import { SectionHeroProductOwner } from '.'

interface SectionProductOwners {
    data?: any;
}


export const SectionProductOwners: FunctionalComponent<SectionProductOwners> = ({ data }) => {

    if (!data) return;
    console.log('data', data)
    const attributes = get(data, 'data.attributes')
    const { Hero } = attributes;
    Hero.Subtitle = 'Owners'

    return [
        <SectionHeroProductOwner data={Hero} />
    ]
};